import axios from "axios";
import { API } from "../utils/apiUrls";

const getHeaders = () => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("Authentication token not found");
  return {
    Authorization: token,
    "Content-Type": "application/json",
  };
};

export const getCallLogs = async ({ merchantId, awbNumber, orderReferenceNumber } = {}) => {
  const params = {};
  if (merchantId) params.merchantId = merchantId;
  if (awbNumber) params.awbNumber = awbNumber;
  if (orderReferenceNumber) params.orderReferenceNumber = orderReferenceNumber;

  const response = await axios.get(API.ndrLiveCallLogs(), {
    params,
    headers: getHeaders(),
    timeout: 30000,
  });

  const data = response.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.call_logs)) return data.call_logs;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const getRecording = async (callLogId) => {
  const response = await axios.get(API.ndrLiveCallRecording(callLogId), {
    headers: getHeaders(),
    timeout: 30000,
  });
  return response.data;
};

const ndrLiveCallService = { getCallLogs, getRecording };
export default ndrLiveCallService;
